export const IPHONE_11 = 'IPHONE_11';
export const IPHONE_X = 'IPHONE_X';
export const IPAD_AIR_2 = 'IPAD_AIR_2';
export const IPAD_PRO_10_5_INCH = 'IPAD_PRO_10_5_INCH';
export const GALAXY_S9 = 'GALAXY_S9';
export const GALAXY_S10_PLUS = 'GALAXY_S10_PLUS';

export const RESPONSIVE = 'Responsive';
export const RESPONSIVE_1280 = 'Responsive - 1280';
export const RESPONSIVE_940 = 'Responsive - 940';
export const RESPONSIVE_1600 = 'Responsive - 1600';

export const IPHONE_11_SIZE = {
  key: 'iPhone 11',
  value: IPHONE_11,
  width: 414,
  height: 896
};

export const IPHONE_X_SIZE = {
  key: 'iPhone X',
  value: IPHONE_X,
  width: 375,
  height: 812
};

export const IPAD_AIR_2_SIZE = {
  key: 'iPad Air 2',
  value: IPAD_AIR_2,
  width: 768,
  height: 1024
};

export const IPAD_PRO_10_5_INCH_SIZE = {
  key: 'iPad Pro 10.5 inch',
  value: IPAD_PRO_10_5_INCH,
  width: 834,
  height: 1112
};

export const GALAXY_S9_SIZE = {
  key: 'Galaxy S9',
  value: GALAXY_S9,
  width: 360,
  height: 740
};

export const GALAXY_S10_PLUS_SIZE = {
  key: 'Galaxy S10+',
  value: GALAXY_S10_PLUS,
  width: 412,
  height: 869
};

export const RESPONSIVE_940_SIZE = {
  key: 'Responsive - 940',
  value: RESPONSIVE_940,
  width: 940,
  height: 700
};

export const RESPONSIVE_1280_SIZE = {
  key: 'Responsive - 1280',
  value: RESPONSIVE_1280,
  width: 1280,
  height: 700
};

export const RESPONSIVE_1600_SIZE = {
  key: 'Responsive - 1600',
  value: RESPONSIVE_1600,
  width: 1600,
  height: 700
};

export const RESPONSIVE_SIZE = {
  key: 'Responsive',
  value: RESPONSIVE,
  width: 1280,
  height: 700
};

export const MOBILE_DEVICES = {
  [IPHONE_11]: IPHONE_11_SIZE,
  [IPHONE_X]: IPHONE_X_SIZE,
  [IPAD_AIR_2]: IPAD_AIR_2_SIZE,
  [IPAD_PRO_10_5_INCH]: IPAD_PRO_10_5_INCH_SIZE,
  [GALAXY_S9]: GALAXY_S9_SIZE,
  [GALAXY_S10_PLUS]: GALAXY_S10_PLUS_SIZE
};

export const DESKTOP_DEVICES = {
  [RESPONSIVE]: RESPONSIVE_SIZE,
  [RESPONSIVE_1280]: RESPONSIVE_1280_SIZE,
  [RESPONSIVE_940]: RESPONSIVE_940_SIZE,
  [RESPONSIVE_1600]: RESPONSIVE_1600_SIZE
};

export const RESPONSIVE_DESKTOP_DEVICES = {
  [RESPONSIVE_1280]: RESPONSIVE_1280_SIZE,
  [RESPONSIVE_940]: RESPONSIVE_940_SIZE,
  [RESPONSIVE_1600]: RESPONSIVE_1600_SIZE
};

export const RESPONSIVE_DEVICES = [
  RESPONSIVE_SIZE,
  RESPONSIVE_1280_SIZE,
  RESPONSIVE_940_SIZE,
  RESPONSIVE_1600_SIZE,
  IPHONE_11_SIZE,
  IPHONE_X_SIZE,
  IPAD_AIR_2_SIZE,
  IPAD_PRO_10_5_INCH_SIZE,
  GALAXY_S9_SIZE,
  GALAXY_S10_PLUS_SIZE
];
